import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useCartActions } from "@/store/useCartStore";

/**
 * Scopes the cart to this restaurant and table. A cart persisted from another
 * table is dropped here rather than silently ordering to the wrong place.
 */
function OrderLayout() {
  const { restaurantId = "", tableId = "" } = useParams<{
    restaurantId: string;
    tableId: string;
  }>();
  const { ensureScope } = useCartActions();

  useEffect(() => {
    if (restaurantId && tableId) {
      ensureScope(restaurantId, tableId);
    }
  }, [restaurantId, tableId, ensureScope]);

  return <Outlet />;
}

export default OrderLayout;
